var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Pictures",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Pictures",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5a1 1 0 11-2 0 1 1 0 012 0z",
    shapeRendering: "geometricPrecision"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12V2a1 1 0 011-1h11a1 1 0 011 1v10a1 1 0 01-1 1H1a1 1 0 01-1-1zm2-9h9v2.338a2.001 2.001 0 00-2.531.369l-3.007 3.34L4.414 8A2 2 0 002 7.682V3zm7.955 4.045L11 8.35V11H6.395l3.56-3.955zM3 9.415L4.586 11H2v-.586l1-1z",
    shapeRendering: "geometricPrecision"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15a1 1 0 011-1h11V5a1 1 0 112 0v10a1 1 0 01-1 1H3a1 1 0 01-1-1z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgImagePackIcon;